import styled, { css } from 'styled-components';
import { DEVICES } from '_constants';

export const HeaderContainer = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 0 0 5px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  box-sizing: border-box;

  @media ${DEVICES.tableView} {
    width: 247px;
    height: 42px;
    padding: 0 10px;
    border: 1px solid rgb(224, 224, 224);
    justify-content: flex-start;

    ${HeaderContainer} {
      display: flex;
    }
  }

  // ${({ isAuditPage }) =>
    isAuditPage &&
    css`
      //   @media ${DEVICES.auditPage} {
      //     width: 247px;
      //     height: 42px;
      //     padding: 0 10px;
      //     border: 1px solid rgb(224, 224, 224);
      //     justify-content: flex-start;
      //
      //     ${HeaderContainer}{
      //       display: flex;
      //     }
      //   }
      //
    `}
`;

export const List = styled.ul`
  position: absolute;
  margin: 0;
  top: 101%;
  right: -1px;
  background: rgb(255, 255, 255);
  border-right: 1px solid rgb(224, 224, 224);
  border-bottom: 1px solid rgb(224, 224, 224);
  border-left: 1px solid rgb(224, 224, 224);
  border-image: initial;
  border-top: none;
  width: 247px;
  white-space: nowrap;
  padding: 10px 20px;
  box-sizing: border-box;
  z-index: 1;

  @media ${DEVICES.tableView} {
    right: auto;
    left: 0;
  }

  // ${({ isAuditPage }) =>
    isAuditPage &&
    css`
      //   @media ${DEVICES.auditPage} {
      //     right: auto;
      //     left: 0;
      //   }
      //
    `}
`;
export const ListItem = styled.li`
  list-style: none;
`;

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
`;
/* eslint-enable */
